"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useStrokeWidth = function (size) {
    return (0, react_1.useMemo)(function () {
        if (size <= 16) {
            return 1.3;
        }
        else if (size <= 24) {
            return 1.5;
        }
        else {
            return 1.8;
        }
    }, [size]);
};
exports.default = useStrokeWidth;
//# sourceMappingURL=use-stroke-width.js.map